import { render, staticRenderFns } from "./cut.vue?vue&type=template&id=71104a20&scoped=true&"
import script from "./cut.vue?vue&type=script&lang=js&"
export * from "./cut.vue?vue&type=script&lang=js&"
import style0 from "./cut.vue?vue&type=style&index=0&id=71104a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71104a20",
  null
  
)

export default component.exports